import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Table } from 'reactstrap'
import { getSelectedCourse } from '../Services/Employees'

const SelectedExam = () => {
  const [employees, seteEmployees] = useState([]);
  const [responseMsg, setResponseMsg] = useState('')
  useEffect(() => {
    getSelectedCourse().then((response) => {
      seteEmployees(response.data);
    }, (error) => {
      setResponseMsg(error.response.data)
    })


  }, [])

  return (
    <div > 
      <div className="card border-0" style={{ background: "white" }}>
       {responseMsg=='' ? <div>
          {/* <div className="header text-center p-3 mb-4" >
            <h5>Selected Exam</h5>
          </div> */}
          <div className="card-header " style={{backgroundColor:"transparent"}} >
          {/* <h6 style={{ textAlign: "center" }}>(Exam Event:<strong>{eventName}</strong> )</h6> */}
          <h5 className="card-title text-center mb-0 py-2">Selected Exam</h5>
        </div>
          
          <div className="card-body">
            <Table hover  className="results-table">
              
              <thead >
          
                <tr >
                  <th>Selected Exam</th>
                  <th>Selected Centre</th>
                  <th>Priority</th>
                </tr>
            
              </thead>
            
              <tbody>
                {employees.map((employee) => {
                  return (
                    <tr key={employee.id}>
                      <td>{employee.courseName}</td>
                      <td>{employee.centerName}</td>
                      <td>{employee.priority}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            </div>
            
       </div> :
          <div className="row">
            <div className='col'>
            <h5>{responseMsg}</h5></div>
          </div>
        }
      </div>
    </div>
  )
}

export default SelectedExam